import { FormBuilder, FormGroup } from '@angular/forms';
import {
  EoFormConfig,
  FormConfig,
  IFormConfig,
} from '../eo-form/eo-form.config';

export interface IEoFormPanelConfig extends IFormConfig {
  header?: string;
  name: string;
  groupName?: string;
  styleClass?: string;
  description?: string;
  descriptionStyleClass?: string;
  panelContentStyleClass?: string;
  headerIcon?: string;
  headerStyleClass?: string;
  visible?: boolean | ((param?: any) => boolean);
}

export class EoFormPanelConfig
  extends FormConfig
  implements IEoFormPanelConfig
{
  header?: string;
  name: string;
  groupName?: string;
  styleClass?: string;
  description?: string;
  descriptionStyleClass?: string;
  panelContentStyleClass?: string;
  headerIcon?: string;
  headerStyleClass?: string;
  visible?: boolean | ((param?: any) => boolean);

  public static getFormFromConfig(
    config: EoFormConfig | EoFormPanelConfig[],
    fB: FormBuilder
  ) {
    let configs;
    if ((config as EoFormConfig)?.config) {
      configs = (config as EoFormConfig).config as EoFormPanelConfig[];
    } else {
      configs = config as EoFormPanelConfig[];
    }

    return fB.group(
      configs?.reduce((acc: any, curr) => {
        acc[curr.name] = fB.group(curr.getFormGroup());
        return acc;
      }, {})
    );
  }

  public static getFormData(form: FormGroup) {
    let formData: any = {};
    Object.keys(form.controls).forEach((key) => {
      let panels = (form.controls[key] as FormGroup).controls;
      formData[key] = {};
      Object.keys(panels).forEach((panel) => {
        formData[key][panel] = panels[panel]?.value;
      });
    });

    return formData;
  }

  public getFormGroupFromForm(form: FormGroup) {
    if (form?.get(this.name)) return form?.get(this.name)! as FormGroup;
    return form;
  }

  // public getFormGroup(fb: FormBuilder){
  //   return fb.group(this.getPanelFormGroup());
  // }

  constructor(obj: IEoFormPanelConfig);
  constructor(obj?: IEoFormPanelConfig) {
    super(obj as IFormConfig);
    this.header = obj?.header;
    this.visible = obj?.visible ?? true;
    this.name = obj?.name ?? '';
    this.styleClass = obj?.styleClass;
    this.panelContentStyleClass = obj?.panelContentStyleClass;
    this.headerIcon = obj?.headerIcon;
    this.headerStyleClass = obj?.headerStyleClass;
    this.groupName = obj?.groupName;
    this.description = obj?.description;
    this.descriptionStyleClass = obj?.descriptionStyleClass;
  }
}
